const FAQS = [
  { q: "Is the AI Guide a medical or financial adviser?", a: "No. The Guide is educational only and will redirect you to a qualified professional for medical, legal, or financial questions." },
  { q: "Why is Deluxe Author Commentary purchase disabled?", a: "Those editions require distinct production and distribution rights review before public sale, per Audible/ACX exclusivity rules." },
  { q: "How do I cancel a Gold or Gold Pro membership?", a: "Visit My Library → Membership for your current plan, or contact support below." },
];

export default function Support() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="support-page">
      <p className="text-xs uppercase tracking-[0.2em] text-textSecondary mb-2">Support</p>
      <h1 className="font-display text-display-sm mb-10">How can we help?</h1>
      <div className="space-y-6">
        {FAQS.map((f, i) => (
          <div key={i} data-testid={`faq-item-${i}`} className="border-b border-white/10 pb-6">
            <p className="font-medium mb-2">{f.q}</p>
            <p className="text-white/75 text-sm">{f.a}</p>
          </div>
        ))}
      </div>
      <p className="text-white/70 text-sm mt-10">Still need help? Reach us at support@endurebeyondpod.com</p>
    </div>
  );
}
